import { isEmpty, findLast, get, findIndex } from 'lodash-es'
import constants from '@/configuration/constants'

/**
 * @function getLinkHref
 * @desc Get the link from a store model
 * @param {object}  [storeModel]  - The store model
 * @param {string}  [linkRel]  - The link we are looking for
 * @return {string} The link
 */
const getLinkHref = (storeModel, linkRel) => {
  if (isEmpty(storeModel)) return

  if (!storeModel.links) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('The link "' + linkRel + '" is missing from object', storeModel)
    }
    return
  }

  const linkObject = findLast(storeModel.links, { 'rel': linkRel })
  if (!linkObject) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('The link "' + linkRel + '" is missing from object', storeModel)
    }
    return
  }

  // Get link href
  let link = get(linkObject, 'href')

  // Encode search if there is already a search in links
  if (link.indexOf('search=') !== -1) {
    // Separate uri and query params
    const linkSplitted = link.split('?')
    // Separate query params
    const queryParams = linkSplitted[1].split('&')
    // Look for search in query params
    const searchParamIndex = findIndex(queryParams, param => param.indexOf('search=') !== -1)
    // Separate search key and value, and encore value
    const searchValue = encodeURIComponent(queryParams[searchParamIndex].split('search=')[1])
    // Recreate search
    queryParams[searchParamIndex] = `search=${searchValue}`
    // Recreate query params
    linkSplitted[1] = queryParams.join('&')
    // Recreate link
    link = linkSplitted.join('?')
  }

  return constants.gmsUrl + link
}

export default getLinkHref
